import { memo, useEffect } from 'react';

const CademiScript: React.FC = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://core.cademi.com.br/assets/js/remote.js';
    script.type = 'text/javascript';
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return <></>;
};

export default memo(CademiScript);
